import React from 'react';
import { motion } from 'framer-motion';

const variants = {
  up: { hidden: { opacity: 0, y: 40 }, visible: { opacity: 1, y: 0 } },
  down: { hidden: { opacity: 0, y: -40 }, visible: { opacity: 1, y: 0 } },
  left: { hidden: { opacity: 0, x: -40 }, visible: { opacity: 1, x: 0 } },
  right: { hidden: { opacity: 0, x: 40 }, visible: { opacity: 1, x: 0 } },
  scale: { hidden: { opacity: 0, scale: 0.92 }, visible: { opacity: 1, scale: 1 } },
  fade: { hidden: { opacity: 0 }, visible: { opacity: 1 } }
};

export const Reveal = ({
  children,
  direction = 'up',
  delay = 0,
  duration = 0.7,
  className = '',
  once = true
}) => (
  <motion.div
    className={className}
    variants={variants[direction]}
    initial="hidden"
    whileInView="visible"
    viewport={{ once, margin: '-60px' }}
    transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const RevealGroup = ({ children, className = '', stagger = 0.12 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: '-60px' }}
    transition={{ staggerChildren: stagger }}
  >
    {children}
  </motion.div>
);

export const RevealItem = ({ children, direction = 'up', className = '', duration = 0.6 }) => (
  <motion.div
    className={className}
    variants={variants[direction]}
    transition={{ duration, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);
